import { IconButton, Stack, Box, styled, useTheme, useMediaQuery, Skeleton } from '@mui/material';

import { themeShadows } from 'app/components/Theme/themeColors';
import { topBarHeight,sideNavWidth,sidenavCompactWidth } from 'app/utils/constant';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NotificationBar from 'app/views/dashboard/components/NotificationBar';
import SearchBox from 'app/views/dashboard/components/SearchBox';
import { useSelector, useDispatch } from 'react-redux';
import { setMode } from 'app/redux/actions/SettingActions';
import updateCounter from 'app/redux/actions/CounterActions';
import UserMenu from 'app/components/UserMenu';
import Icon from 'app/components/Icon';
import Logo from 'app/components/Logo';
import Avatar from 'app/components/Avatar';
import Messages from 'app/views/dashboard/Messages';
import Notifications from 'app/views/dashboard/Notifications';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  '& .fa':{ width:"22px", height:"22px", lineHeight:"21px" },
   marginLeft:"2px",
  color:"#FFF", [theme.breakpoints.up('sm')]: { marginLeft:"-10px", }
}));

const TopbarRoot = styled('div')(({ theme, fixed = 0, mode = 'full' }) => ({
  top: 0,
  zIndex: 96,
  transition: `all 0.${mode === 'full' ? 60 : 20}s ease`,
  boxShadow: themeShadows[8],
  height: topBarHeight,
  position: fixed ? "fixed" : "static",
  right: 0,
  left: `${mode === 'full' ? sideNavWidth : (mode === 'compact' ? sidenavCompactWidth : 0)}px`,
}));

const TopbarContainer = styled(Box)(({ theme }) => ({
  padding: '8px',
  paddingLeft: 18,
  paddingRight: 20,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: theme.palette.secondary.main,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 6,
    paddingRight: 10,
  },
  [theme.breakpoints.down('xs')]: {
    paddingLeft: 14,
    paddingRight: 16,
  },
}));

const PokeItem = styled(Stack)(({ theme, border = 0 }) => ({
    padding:'13px',
    background:"#FFF",
    gap:"9px",
    border:"0",
    borderBottom:`1px solid #eee`,
    borderRadius:border ? 0 : "2px",
    '& .pht': {
        cursor:"pointer",
        width:'40px',
        height:'40px',
        padding:'1px',
        border:"1px solid #eee",
        borderRadius:"50%",
        display:"flex",
    },
    '& .dtl': { display:"flex", flex:"1" , flexDirection:"column",  width:"calc(100% - 70px)",  justifyContent: 'center',
        '& a':{ marginBottom: '2px', textDecoration:"none", fontSize:"13px", fontWeight:"bold", lineHeight: '16px', overflow:"hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '100%', display: 'block', },
        '& .ln': { margin:0, overflow:"hidden", fontSize:"12.1px", whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '100%', display: 'block', lineHeight:"18px",
            '& .fa,& .far': { fontSize:"14px", textAlign:"center", width:"14px", margin:"0 2px 0 0" } 
        },
        '& .dot': { display: 'inline-flex', background: '#888', width: '4px',height: '4px',borderRadius: '50%', margin: '-1px 7px 0 7px' },
        '& .btn': { marginTop:'7px' }
    },
}));

const Layout1Topbar = ({ fixed }) => {
  const theme = useTheme();
  const auth = useSelector(store=>store.auth);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));
  const mode = useSelector(store=>store.settings.layout1Settings.leftSidebar.mode);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  /*
  const updateSidebarMode = (sidebarSettings) => {
    updateSettings({
      layout1Settings: { leftSidebar: { ...sidebarSettings } },
    });
  };
  */

  const handleSidebarToggle = () => {
  // let { layout1Settings } = settings;
    let _mode;
    if (isMdScreen) {
      _mode = mode === 'close' ? 'mobile' : 'close';
    } else {
      _mode = mode === 'full' ? 'compact' : 'full';
    }
    dispatch(setMode(_mode));
    //updateSidebarMode({ mode });
  };

  const renderItem =(type,item,idx, buttons, close, sk = false) =>{

      if( type === 'pokes' || type === 'requests' ){

        if( sk ){
            return <PokeItem direction="row">
              <div className="pht">
                <Skeleton variant="circular" width={36} height={36}/>
              </div>
              <div className="dtl">
                  <Skeleton variant="rounded" style={{ borderRadius:"5px", marginBottom:"6px" }} width={80} height={14} />
                  <p className="ln" style={{ flexDirection:"row", display: 'flex',gap: '5px' }}>
                    <Skeleton variant="rounded" width={13} height={13} style={{ borderRadius:"5px" }} />
                    <Skeleton variant="rounded" width={40} height={13} style={{ borderRadius:"5px" }} />
                    <Skeleton variant="rounded" width={30} height={13} style={{ borderRadius:"5px" }} />
                    <Skeleton variant="rounded" width={70} height={13} style={{ borderRadius:"5px" }} />
                  </p>
                  <p className="ln" style={{ flexDirection:"row", marginTop:"5px", display: 'flex',gap: '5px' }}>
                    <Skeleton variant="rounded" width={13} height={13} style={{ borderRadius:"5px" }} />
                    <Skeleton variant="rounded" width={100} height={13} style={{ borderRadius:"5px" }} />
                  </p>
                  <p className="ln" style={{ flexDirection:"row", marginTop:"9px", display: 'flex',gap: '5px' }}>
                    <Skeleton variant="rounded" width={77} height={32} style={{ borderRadius:"5px" }} />
                    <Skeleton variant="rounded" width={36} height={32} style={{ borderRadius:"5px" }} />
                  </p>

              </div>
            </PokeItem>;
        };

        return (
          <PokeItem direction="row">
            <div className="pht">
              <Avatar size={36} name={`${item.firstname} ${item.lastname}`} url={item.image} onClick={()=>{ close(false); navigate(`/user/${item.username}`,{ state:item}) }} />
            </div>
            <div className="dtl">
              <a href={`/user/${item.username}`} onClick={(e)=>{ e.preventDefault(); close(false); navigate(`/user/${item.username}`,{ state:item}) }}>{item.firstname} {item.lastname}</a>

              <p className="ln">
                  <Icon className="gender">{item.gender ===   'F' ? 'female' : 'male'}</Icon>
                  {item.extra?.gender || "Male"} 
                  <span className="dot"></span>
                  {item.extra?.age} 
                  <span className="dot"></span>
                  {item?.extra.relationship_status}
              </p>
              {item.extra?.location && <p className="ln"><Icon>map-marker</Icon>{item.extra?.location || null}</p>}
              {buttons && <div className="btn">{buttons}</div>}

            </div>
          </PokeItem>
        ) 
      }

      return null;
  }

  return (
    <TopbarRoot fixed={fixed ? 1 : 0} mode={mode}>
      <TopbarContainer>

        <Stack direction="row" spacing={`${isMobile ? 10 :15}px`}>
          <StyledIconButton onClick={handleSidebarToggle}>
            <Icon size={19}>bars</Icon>
          </StyledIconButton>
          {isMdScreen && <Logo small={true} />}
        </Stack>
        
        <SearchBox /> 
        <Box display="flex" alignItems="center">
            
          <NotificationBar 
            icon="thumbs-up:r" 
            iconActive="thumbs-up" 
            badge="pokes" 
            title="Pokes" 
            url={`user/pokes/${auth?.user?.ID || 0}`} 
            maxLimit={false} 
            limit={100} 
            reload={true}
            errorMargin={20}
            renderItem={(item,idx,buttons,close)=>renderItem('pokes',item,idx,buttons,close)} 
            onRemove={itms=>dispatch(updateCounter({pokes:itms.length}))} 
            onCounter={ttl=>dispatch(updateCounter({pokes:ttl}))} 
            emptyText="No pokes yet" 
            skeleton={(item,i)=>renderItem('pokes', item, i, null, ()=>{}, true)}
            buttons={[
                { icon: "thumbs-up:r", text:"Poke", key:"ID", url:"user/action/poke/[KEY]",  method:"POST", remove: true },
                { icon: "trash:r", bg:'red', key:"ID", url:"user/action/cancelpoke/[KEY]",  method:"POST", remove: true, variant:"outlined", color:"#d00", borderColor:"#d00" }
            ]} 
          />

          {!(location?.pathname || '').toString().includes('/friend-requests') && <NotificationBar 
            icon="user-plus:r" 
            iconActive="user-plus" 
            badge="requests" 
            title="Friend Requests" 
            url={`user/friend-requests/${auth?.user?.ID || 0}`} 
            limit={10} 
            viewMore="dashboard/friend-requests" 
            reload={true}
            errorMargin={20}
            renderItem={(item,idx,buttons,close)=>renderItem('pokes',item,idx,buttons,close)} 
            //onRemove={itms=>dispatch(updateCounter({requests:itms.length}))} 
            onCounter={ttl=>dispatch(updateCounter({requests:ttl}))} 
            emptyText="No friend request yet" 
            skeleton={(item,i)=>renderItem('requests', item, i, null, ()=>{}, true)}
            buttons={[
                { icon: "user-plus", text:"Accept", key:"ID", url:"user/action/acceptrequest/[KEY]",  method:"POST", remove: true },
                { icon: "user-times", bg:'red', key:"ID", url:"user/action/rejectrequest/[KEY]",  method:"POST", remove: true, variant:"outlined", color:"#d00", borderColor:"#d00" }
            ]}
          />}

          {(isMobile || !(location?.pathname || '').toString().includes('/messages')) && <NotificationBar reload={true} hideLoading={true} icon="envelope:r" iconActive="envelope" badge="messages" title="Messages" url={`chat/list`} emptyText="No notification yet" limit={10} viewMore="dashboard/messages" filterItems={data=>{
                data = data.sort((a, b) => b.timestamp - a.timestamp);
                return data;
              }} component={(state,gs,close,shw)=>{
              return <React.Fragment>
                {shw && <Messages items={state.data || []} initLoading={state.isLoading} onClick={()=>close(false)} />}
                </React.Fragment>
            }}
          />}

          {(isMobile || !(location?.pathname || '').toString().includes('/notifications')) && <NotificationBar reload={true} icon="bell:r" iconActive="bell" badge="notifications" title="Notifications" hideLoading={true} url={`user/notifications/${auth?.user?.ID || 0}`} limit={10} viewMore="dashboard/notifications" component={(state,gs,close)=><Notifications loading={!state.loaded && state.isLoading} items={state.data || []} onClick={()=>close(false)} spacing={0}  emptyText="No message yet" border={1} bcolor="#eee" />}
          />}

          <UserMenu source="dashboard"/>
        </Box>
      </TopbarContainer>
    </TopbarRoot>
  );
};

export default React.memo(Layout1Topbar);
